module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-container"
  }, [_c('footer', {
    staticClass: "footer",
    class: {
      'content-full': _vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/onBoard' || _vm.$route.path === '/terms' || _vm.$route.path.indexOf('/onBoardMember') !== -1
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-left"
  }, [_c('p', [_vm._v("© 2020 Straticom Technologies R&D, all rights reserved.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-right"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/footerLogo.png"),
      "alt": "Site Logo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23cc4fc5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/FooterBar.vue
// module id = 364
// module chunks = 5